/**
 * A stack overflow from Google Translate's injected script, which recurses
 * in-page. Chromium names that script `<anonymous>`. Chrome for iOS and the
 * Google iOS app report it only by the page URL, which is also how our inline
 * Twig scripts report, so the page-URL shape matches only on those two apps.
 *
 * @param {{value?: unknown, stacktrace?: {frames?: Array<{filename?: unknown, abs_path?: unknown}>}}|null} exception
 *   The primary Sentry exception value
 * @param {string} userAgent
 * @returns {boolean} true when the event matches a known foreign-script signature
 */
export function isForeignStackOverflow(exception, userAgent) {
    if (!exception || typeof exception.value !== 'string'
        || !exception.value.includes('Maximum call stack size exceeded')) {
        return false;
    }
    const frames = (exception.stacktrace && exception.stacktrace.frames) || [];
    if (frames.length > 0 && frames.every((frame) => frame.filename === '<anonymous>')) {
        return true;
    }
    const inScriptFile = frames.some((frame) => [frame.filename, frame.abs_path]
        .some((file) => typeof file === 'string' && /\.js(?:[?#]|$)/.test(file)));
    return !inScriptFile && /\b(?:CriOS|GSA)\//.test(userAgent);
}
